import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Radar } from "lucide-react";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Guard against StrictMode double-invoke
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const run = async () => {
      const hash = location.hash || window.location.hash || "";
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : null;
      if (!sessionId) {
        navigate("/", { replace: true });
        return;
      }
      try {
        const { data } = await api.post(
          "/auth/session",
          { session_id: sessionId },
          { withCredentials: true },
        );
        setUser(data);
        // Clear hash and redirect to app
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user: data } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    };
    run();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: "var(--bg-main)" }}>
      <div className="text-center">
        <Radar className="w-12 h-12 mx-auto blink" style={{ color: "var(--primary-accent)" }} />
        <div className="hud-caption mt-4">AUTHENTICATING OPERATOR...</div>
      </div>
    </div>
  );
};

export default AuthCallback;
